import React from 'react';
import { motion } from 'framer-motion';

if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    .no-interact {
      -webkit-user-select: none !important;
      -webkit-touch-callout: none !important;
      -webkit-user-drag: none !important;
      user-select: none !important;
      pointer-events: none !important;
      -webkit-tap-highlight-color: transparent !important;
    }
  `;
  document.head.appendChild(style);
}

const About = () => {
  const stats = [
    { label: 'Trayectoria', value: 'Desde 2002' },
    { label: 'Origen', value: '100% Mexicana' },
    { label: 'Especialidad', value: 'Suministros' },
    { label: 'Valor', value: 'Innovación' },
  ];

  return (
    <div className="min-h-screen bg-white text-slate-900 pt-32 pb-20 px-6 selection:bg-[#a6192e] selection:text-white">
      <div className="max-w-7xl mx-auto">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-24">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6 flex flex-col items-start"
          >
            <span className="text-[#a6192e] font-black text-xs tracking-[0.5em] uppercase italic">
              Servirte para innovar
            </span>

            <div
              className="w-full max-w-[450px] aspect-[4/3] md:aspect-video rounded-[3rem] overflow-hidden no-interact"
              style={{
                backgroundImage: 'url("/grupo_diana_02.png")',
                backgroundSize: 'contain', 
                backgroundPosition: 'left center', 
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'transparent' 
              }}
              aria-label="Grupo Diana"
            >
              <div className="w-full h-full bg-transparent" />
            </div>

            <p className="text-slate-500 text-lg leading-relaxed italic max-w-xl pt-4">
              Como empresa familiar, entendemos el valor del esfuerzo y la importancia de construir relaciones a largo plazo. Por ello, nuestra filosofía de trabajo no se basa solo en vender productos, sino en formar parte del éxito de nuestros clientes, acompañándolos en cada paso de su proceso creativo.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="relative bg-gray-50 border border-gray-100 p-10 rounded-[3rem] shadow-xl shadow-gray-100 overflow-hidden"
          >
            <div className="absolute -right-10 -bottom-10 w-40 h-40 bg-[#a6192e]/5 rounded-full blur-3xl"></div>
            <p className="text-slate-600 italic leading-relaxed relative z-10 text-lg">
              "Nacimos en el año <span className="text-[#a6192e] font-bold text-2xl">2002</span> como un pequeño emprendimiento familiar. Hoy, somos una empresa consolidada que dota a fabricantes de los materiales necesarios para competir en el mercado actual."
            </p>
          </motion.div>

        </div>

        <section className="py-24 px-6 max-w-7xl mx-auto overflow-hidden">
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-12 mb-24 border-l-4 border-[#a6192e] pl-8 md:pl-16">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="max-w-2xl"
            >
              <span className="text-[#a6192e] font-black text-xs tracking-[0.5em] uppercase italic mb-6 block">
                Compromiso Diana
              </span>
              <h2 className="text-6xl md:text-8xl font-black italic tracking-tighter uppercase leading-[0.85] text-slate-900">
                LA EXCELENCIA <br />
                <span className="text-[#a6192e]">NO ES OPCIONAL</span>
              </h2>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="lg:max-w-md"
            >
              <div className="relative p-10 bg-gray-50 rounded-[2.5rem] border border-gray-100 shadow-sm overflow-hidden group/text">
                <span className="absolute -right-4 -bottom-10 text-[10rem] font-black text-gray-200/40 italic select-none transition-transform duration-1000 group-hover/text:-translate-x-8">E</span>

                <p className="text-slate-600 italic leading-relaxed relative z-10 text-base md:text-lg">
                  Basamos nuestro servicio diario en <span className="text-[#a6192e] font-bold">tres valores fundamentales</span> que definen nuestra identidad y aseguran el éxito de cada proyecto que acompañamos.
                </p>
              </div>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              whileHover={{ y: -12 }}
              className="bg-white border border-gray-100 p-10 rounded-[3rem] shadow-xl shadow-gray-100/30 hover:border-[#a6192e]/20 transition-all group cursor-default"
            >
              <div className="w-16 h-16 bg-gray-50 rounded-2xl mb-8 flex items-center justify-center relative overflow-hidden transition-all duration-500 group-hover:bg-[#a6192e] group-hover:shadow-xl group-hover:shadow-red-200">
                <motion.div
                  whileHover={{ rotate: [0, -10, 10, 0] }}
                  className="relative z-10"
                >
                  <svg className="w-8 h-8 text-[#a6192e] group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                  </svg>
                </motion.div>
              </div>
              <h4 className="font-black italic text-2xl uppercase mb-4 tracking-tighter text-slate-900 leading-none">Rapidez</h4>
              <p className="text-slate-500 text-sm italic leading-relaxed">
                Sabemos que tu producción no puede esperar. Optimizamos nuestros procesos para ofrecerte tiempos de entrega récord y stock siempre disponible.
              </p>
            </motion.div>
            <motion.div
              whileHover={{ y: -12 }}
              className="bg-white border border-gray-100 p-10 rounded-[3rem] shadow-xl shadow-gray-100/30 hover:border-[#a6192e]/20 transition-all group cursor-default"
            >
              <div className="w-16 h-16 bg-gray-50 rounded-2xl mb-8 flex items-center justify-center relative overflow-hidden transition-all duration-500 group-hover:bg-[#a6192e] group-hover:shadow-xl group-hover:shadow-red-200">
                <motion.div className="relative z-10 transition-transform duration-500 group-hover:scale-110">
                  <svg className="w-8 h-8 text-[#a6192e] group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </motion.div>
              </div>
              <h4 className="font-black italic text-2xl uppercase mb-4 tracking-tighter text-slate-900 leading-none">Eficacia</h4>
              <p className="text-slate-500 text-sm italic leading-relaxed">
                No solo entregamos materiales, entregamos soluciones. Nos aseguramos de que cada herraje, cierre o sintético cumpla con los más altos estándares de calidad y durabilidad.
              </p>
            </motion.div>
            <motion.div
              whileHover={{ y: -12 }}
              className="bg-white border border-gray-100 p-10 rounded-[3rem] shadow-xl shadow-gray-100/30 hover:border-[#a6192e]/20 transition-all group cursor-default"
            >
              <div className="w-16 h-16 bg-gray-50 rounded-2xl mb-8 flex items-center justify-center relative overflow-hidden transition-all duration-500 group-hover:bg-[#a6192e] group-hover:shadow-xl group-hover:shadow-red-200">
                <motion.div className="relative z-10 transition-transform duration-500 group-hover:rotate-[360deg]">
                  <svg className="w-8 h-8 text-[#a6192e] group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </motion.div>
              </div>
              <h4 className="font-black italic text-2xl uppercase mb-4 tracking-tighter text-slate-900 leading-none">Cordialidad</h4>
              <p className="text-slate-500 text-sm italic leading-relaxed">
                El trato humano es nuestra esencia. Nos apasiona escuchar a nuestros clientes, brindando una atención amable, personalizada y cercana que nos hace sentir como parte de tu equipo.
              </p>
            </motion.div>
          </div>
        </section>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="text-center py-24 bg-gray-50 rounded-[4rem] border border-gray-100 relative overflow-hidden"
        >
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#a6192e]/5 via-transparent to-transparent pointer-events-none" />

          <div className="relative z-10 px-4 max-w-5xl mx-auto">
            <h3 className="text-4xl md:text-6xl font-black italic uppercase tracking-tighter mb-8 text-slate-900 leading-none">
              “Si buscas innovar en <span className="text-[#a6192e]">nosotros</span> <br className="hidden md:block" /> debes confiar.”
            </h3>
            <div className="max-w-2xl mx-auto mb-16">
              <p className="text-slate-500 text-base md:text-lg italic leading-relaxed">
                Más de <span className="text-slate-900 font-bold">20 años de experiencia</span> nos respaldan, pero es nuestra visión hacia el futuro y el compromiso con tu marca lo que nos motiva a seguir innovando día con día.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto border-t border-gray-200/60 pt-12">
              {stats.map((s, i) => (
                <div key={i} className="text-center group">
                  <p className="text-[#a6192e] font-black text-3xl md:text-4xl tracking-tighter italic mb-1 transition-transform group-hover:scale-110 duration-300">
                    {s.value}
                  </p>
                  <p className="text-slate-400 text-[9px] md:text-[10px] font-black uppercase tracking-[0.25em] italic">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;